import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgJobsIcon({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 28 28"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				d="M23.6251 16.5083V21.4667C23.6251 22.743 22.7069 23.842 21.4411 24.01C19.0062 24.3332 16.5224 24.5 14.0001 24.5C11.4777 24.5 8.9939 24.3332 6.55906 24.01C5.29323 23.842 4.37506 22.743 4.37506 21.4667V16.5083M23.6251 16.5083C23.9021 16.2676 24.1237 15.9697 24.2748 15.6352C24.4258 15.3007 24.5027 14.9375 24.5001 14.5705V10.157C24.5001 8.89583 23.6041 7.80617 22.3569 7.6195C21.0354 7.42166 19.7073 7.27106 18.3751 7.168M23.6251 16.5083C23.3987 16.7008 23.1351 16.8525 22.8399 16.9517C19.9888 17.8976 17.004 18.3782 14.0001 18.375C10.9107 18.375 7.93923 17.8745 5.16023 16.9517C4.87237 16.8559 4.60575 16.7054 4.37506 16.5083M4.37506 16.5083C4.09803 16.2676 3.87639 15.9697 3.72535 15.6352C3.57431 15.3007 3.49745 14.9375 3.50006 14.5705V10.157C3.50006 8.89583 4.39606 7.80617 5.64323 7.6195C6.96471 7.42165 8.29284 7.27106 9.62506 7.168M18.3751 7.168V6.125C18.3751 5.42881 18.0985 4.76113 17.6062 4.26884C17.1139 3.77656 16.4463 3.5 15.7501 3.5H12.2501C11.5539 3.5 10.8862 3.77656 10.3939 4.26884C9.90163 4.76113 9.62506 5.42881 9.62506 6.125V7.168M18.3751 7.168C15.4627 6.94292 12.5374 6.94292 9.62506 7.168M14.0001 14.875H14.0094V14.8843H14.0001V14.875Z"
				stroke={finalColor}
				strokeWidth={1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
export default SvgJobsIcon;
